export default __webpack_public_path__ + "static/media/35_old.2c88d249.png";